"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBox = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const common_1 = require("../../common");
const layout_1 = require("../base/layout");
const MenuBody_1 = __importDefault(require("./MenuBody"));
const action_1 = require("./action");
const function_1 = require("./function");
exports.MenuBox = react_1.default.memo(({ isTeacher, name, isWhite, menuList, hideBody = false, hideMenu = false, }) => {
    const [menuOpen, setMenuOpen] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { depths, menu } = (0, react_redux_1.useSelector)((state) => (0, function_1.getMenuData)(state), react_redux_1.shallowEqual);
    const updateNewMenu = (menu, id) => {
        dispatch((0, action_1.updateMenu)(depths, menu, id));
    };
    (0, react_1.useEffect)(() => {
        const handlerUpdateMenu = (data) => {
            const { menuDetail, id, props } = data;
            dispatch((0, action_1.updateMenu)(depths, { menu: menu.menu, detail: menuDetail || 'list' }, id, props));
        };
        APP.eventManager.subscribe('UPDATE_DETAIL_MENU', handlerUpdateMenu);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_DETAIL_MENU', handlerUpdateMenu);
        };
    }, [depths, menu]);
    const questionTypeList = (0, react_1.useMemo)(() => {
        return menuList.map(menu => {
            return {
                id: menu,
                title: `menu.${menu}`,
            };
        });
    }, [menuList]);
    const questionType = (0, react_1.useMemo)(() => {
        return questionTypeList.find(item => item.id === menu?.menu);
    }, [menu, questionTypeList]);
    const { isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isDesktop && !hideMenu ? (react_1.default.createElement(layout_1.DSBodyLeftLayout, null,
            react_1.default.createElement(common_1.MenuBar, { className: `menu-l ${name}`, isRow: false, isClickDisabled: false, list: menuList, value: menu?.menu, onItemClick: (changeMenu) => {
                    updateNewMenu({
                        menu: changeMenu === 'learningSupportRoom'
                            ? 'notice'
                            : changeMenu === 'learningManagement' ||
                                changeMenu === 'myRoom'
                                ? 'test'
                                : changeMenu === 'liveRoom'
                                    ? 'reservation'
                                    : changeMenu,
                        detail: 'list',
                    });
                }, option: {
                    titleIcon: {
                        show: true,
                        size: 34,
                        color: Colors_1.Colors.w_grey,
                        focus: Colors_1.Colors.light_tur,
                    },
                } }))) : (hideBody && !hideMenu && (react_1.default.createElement(common_1.DropDown, { className: `dropdown-mobile ${name}`, value: questionType, styles: {
                titleWrap: {
                    display: 'flex',
                    paddingTop: 3,
                },
            }, option: {
                titleIcon: {
                    show: true,
                    name: menuOpen ? 'menu_close' : 'menu_open',
                    size: 18,
                    color: isWhite
                        ? Colors_1.Colors.white
                        : menuOpen
                            ? Colors_1.Colors.light_grey
                            : Colors_1.Colors.black,
                },
                downIcon: {
                    show: false,
                },
                itemIcon: {
                    show: true,
                    size: 35,
                },
            }, list: questionTypeList, setDropValue: (value) => {
                const changeMenu = value.id;
                updateNewMenu({
                    menu: changeMenu === 'learningSupportRoom'
                        ? 'notice'
                        : changeMenu === 'learningManagement' ||
                            changeMenu === 'myRoom'
                            ? 'test'
                            : changeMenu === 'liveRoom'
                                ? 'reservation'
                                : changeMenu,
                    detail: 'list',
                });
            }, isHeaderTitle: true, setMenuOpen: setMenuOpen }))),
        !hideBody &&
            (isDesktop ? (react_1.default.createElement(layout_1.DSBodyRightLayout, null,
                react_1.default.createElement(MenuBody_1.default, { isTeacher: isTeacher }))) : (react_1.default.createElement(MenuBody_1.default, { isTeacher: isTeacher })))));
});
